// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"az_fPc","citrusCarousel":"az_gPc"};